/**
 * Visszadja az aktuális elem bal, fent, szélesség és magasság értékét objektumként
 * @param element object
 * @return object
 */
export default function getElementProperties(element) {
	return {
		top: Math.floor(element.offset().top),
		left: Math.floor(element.offset().left),
		width: Math.ceil(element.prop('offsetWidth')),
		height: Math.ceil(element.prop('offsetHeight'))

	};
}
